<template>
  <div :style="desktopStyles.menu">
    <!--Coupons-->
    <shop-header :store-id="storeid" />
    <section class="bg-white position-sticky" style="top:-1px;z-index:4">
      <div class="container-fluid" :style="desktopStyles.nav" v-if="getloadedMenu">
        <div class="container" ref="container" v-if="storeMenu">
          <resturant-menu :categories="storeMenu.Categories" />
        </div>
      </div>
    </section>
    <div class="container root">
      <div class="row main-container" v-if="storeMenu && getloadedMenu">
        <main :class="computeProductListClass">
          <ProductList :menu="setMenu()" @update-containerWidth="p=>updateWidth(p)" />
        </main>
        <aside v-if="!isDigitalDisplay" :class="shoppingCartClass" id="shopping-cart">
          <div
            class="category-title"
            v-if="storeMenu.Categories && storeMenu.Categories.length > 0"
          />
          <ShoppingCart :isFromHomePage="true" />
        </aside>
      </div>
      <progressindicator v-else style="opacity:0.4"></progressindicator>
    </div>
    <shopfooter />
    <order-type v-if="showOrderTypeSelection"></order-type>
  </div>
</template>
<script>
import ProductList from "./products/ProductList";
import ShoppingCart from "./shopping-cart/ShoppingCart";
import ResturantMenu from "./../shared/menu";
import ShopHeader from "./partials/shopheader";
import shopfooter from "./../shared/shopfooter";
import { mapMutations, mapActions, mapGetters } from "vuex";
import Progressindicator from "../progressindicator";
import OrderType from "./OrderType";
import sharedScripts from '../../sharedscripts/shop/Shop';

export default {
  components: {
    ProductList,
    ShoppingCart,
    ResturantMenu,
    ShopHeader,
    shopfooter,
    Progressindicator,
    OrderType
  },
  props: {
    storeid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      productListClass: "col-xl-8 col-md-7 col-sm-6",
      shoppingCartClass: "col-xl-4 col-md-5 col-sm-6",
      showOrderTypeSelection: false,
    };
  },
  computed: {
    ...sharedScripts.computed,
    ...mapGetters([
      "storeMenu",
      "desktopStyles",
      "getloadedMenu",
      "isDigitalDisplay",
      "currentStoreDoc",
      "selectedCompany",
    ]),
    computeProductListClass() {
      if (this.isDigitalDisplay) {
        return "col-xl-12 col-md-12 col-sm-12";
      } else {
        return this.productListClass;
      }
    }
  },
  watch: {
    ...sharedScripts.watch,
  },
  created() {
    if(this.currentStoreDoc && this.storeid != this.currentStoreDoc.ID)
    {
      this.setCurrentStoreDoc(null);
    }
  },
  mounted() {
    const self = this;
    this.setStore(this.storeid);
    this.initStore({
      storeId: this.storeid,
      callback: () => {
          self.initiateWorkflow();
          self.setStoreLoaded();
      },
    });
    this.getStoreMenu(this.storeid);
    this.setShowDeliveryFee(false);
    this.updateShoppingCartItems();
  },
  methods: {
    ...sharedScripts.methods,
    ...mapMutations(["setStore", "setStoreLoaded", "setShowDeliveryFee","setCurrentStoreDoc"]),
    ...mapActions([
      "initStore",
      "getStoreMenu",
      "insertErrorlog",
      "redirectToErrorPage",
      "updateShoppingCartItems"
    ]),
    setMenu() {
      return JSON.parse(JSON.stringify(this.storeMenu));
    },
    updateWidth(width) {
      if (width > 992) {
        this.productListClass = "col-xl-8 col-md-7 col-sm-6";
        this.shoppingCartClass = "col-xl-4 col-md-5 col-sm-6";
      } else {
        this.productListClass = "col-xl-6 col-md-6 col-sm-6";
        this.shoppingCartClass = "col-xl-6 col-md-6 col-sm-6";
      }
    }
  }
};
</script>
